export interface FooterConfig {
    'enable-logo': string;
    'open-links-in-new-tab': string;
    'enable-newsletter': string;
    'enable-content': string;
    'enable-payment-methods': string;
    'enable-partners': string;
}

const footerPresets = {
    full: {
        'enable-logo': 'true',
        'open-links-in-new-tab': 'true',
        'enable-newsletter': 'true',
        'enable-content': 'true',
        'enable-payment-methods': 'true',
        'enable-partners': 'true',
    },
    minimal: {
        'enable-logo': 'true',
        'open-links-in-new-tab': 'true',
        'enable-newsletter': 'false',
        'enable-content': 'true',
        'enable-payment-methods': 'true',
        'enable-partners': 'true',
    },
} as const;

export function getFooterConfig(routeName: string): FooterConfig {
    if (
        routeName.includes('checkout') ||
        routeName.includes('payment') ||
        routeName.includes('pre-checkout') ||
        routeName.includes('post-checkout') ||
        routeName.includes('flight')
    ) {
        return footerPresets.minimal;
    }
    return footerPresets.full;
}

export function applyFooterConfig(element: HTMLElement, config: FooterConfig) {
    Object.entries(config).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
}
